import { Job, SupabaseJob } from '@applicator/shared'

import { devLog } from '../../../lib/devLog'

// Фильтрация вакансий по активному статусу, поисковому запросу и релевантности
export function filterJobs(
  jobs: Job[],
  activeStatus: string | null,
  searchQuery: string,
  relevanceFilter: string,
  supabaseJobs: SupabaseJob[]
): Job[] {
  devLog('[filterJobs] START', {
    jobsCount: jobs.length,
    activeStatus,
    searchQuery,
    relevanceFilter,
    supabaseJobsCount: supabaseJobs.length,
  })
  const result = jobs.filter((job) => {
    // Фильтр по статусу
    const matchesStatus = !activeStatus || job.status === activeStatus
    
    // Фильтр по поисковому запросу (по названию вакансии и компании)
    const matchesSearch = (() => {
      if (!searchQuery) return true
      const searchLower = searchQuery.toLowerCase().trim()
      if (!searchLower) return true // Пустая строка после trim = показывать все
      const positionMatch = job.position?.toLowerCase().includes(searchLower) || false
      const companyMatch = job.company?.toLowerCase().includes(searchLower) || false
      return positionMatch || companyMatch
    })()

    // Фильтр по релевантности
    const matchesRelevance = (() => {
      if (relevanceFilter === 'all') return true
      
      const jobId = job.id || ''
      const supabaseJob = supabaseJobs.find(j => j.id === jobId)
      
      if (relevanceFilter === 'relevant') {
        if (supabaseJob?.rejected_from_relevant) return false
        return supabaseJob?.relevance_verdict === 'Fit'
      } else if (relevanceFilter === 'non-relevant') {
        return supabaseJob?.relevance_verdict === 'No Fit'
      } else if (relevanceFilter === 'not-analyzed') {
        return supabaseJob?.relevance_verdict === null || supabaseJob?.relevance_verdict === undefined
      }
      
      return true
    })()
    
    const matches = matchesStatus && matchesSearch && matchesRelevance
    if (!matches) {
      devLog('[filterJobs] Job filtered out', {
        jobId: job.id,
        position: job.position,
        company: job.company,
        status: job.status,
        matchesStatus,
        matchesSearch,
        matchesRelevance,
      })
    }
    return matches
  })
  devLog('[filterJobs] END', {
    inputCount: jobs.length,
    outputCount: result.length,
    filteredOut: jobs.length - result.length,
  })
  return result
}
